module.exports = "<div class=\"kl-group\">\n    {#inc this.$body}\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ../src/js/components/form/KLGroup/index.html
// module id = 453
// module chunks = 0